let unauthorizedHandler = null;

export function setUnauthorizedHandler(handler) {
  unauthorizedHandler = handler;
}

export function triggerUnauthorized(reason = 'Session expired. Please log in again.') {
  if (typeof unauthorizedHandler === 'function') {
    unauthorizedHandler(reason);
  }
}
